import $ from 'jquery'

function init () {
  registerShowPrivacyButtonClickHandler()
}

function registerShowPrivacyButtonClickHandler () {
  /**
   * It is possible that a privacy page contain more than one
   * HTML button to open a privacy settings dialog.
   */
  let $dataProtectionButtons = $('.ppms_cm_privacy_settings_button_show')

  /**
   * Register a handler on every button to open the privacy settings dialog.
   */
  $dataProtectionButtons.each(function () {
    $(this).on('click', function () {
      if (OneTrust) {
        // Consent Banner is initially hidden on the privacy page.
        $('#onetrust-consent-sdk').addClass('force-unhide')

        // Opens the preference center dialog
        OneTrust.ToggleInfoDisplay()

        // Duct Tape: Hide the yes / no consent banner which occur in the background behind the
        // preference center dialog.
        let consentBanner = $('#onetrust-banner-sdk')
        if (consentBanner) {
          consentBanner.hide()
        }

        document.getElementById('close-pc-btn-handler').onclick = function () {
          OneTrust.Close()
        }
      }
    })
  })
}

export default {
  init
}
